export const IS_OPEN_MOBILE_MENU = 'IS_OPEN_MOBILE_MENU';
